<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              
              <el-form-item label="案卷号">
                  <el-input style="width: 177px" v-model="queryForm.archiveNo"></el-input>
              </el-form-item>
              <el-form-item label="申请人">
                  <el-input style="width: 177px" v-model="queryForm.applyEntity"></el-input>
              </el-form-item>
              <el-form-item label="申请日期">
                  <!-- <el-input  v-model="queryForm.applyDate"></el-input> -->
                  <el-date-picker
                    style="width: 177px"
                    v-model="queryForm.applyDate"
                    type="date"
                    value-format="yyyy.M.d"
                    placeholder="选择日期">
                  </el-date-picker>
              </el-form-item>
              <el-form-item
                label="申请区间"
                prop="startApplyDate"
              >
                <!-- <el-input
                  size="small"
                  v-model="propertyPatent.applyStatus"
                  :disabled="propertyPatentState == 'check'"
                  style="width: 177px"
                ></el-input> -->
                <el-date-picker
                  v-model="dataLabel1"
                  type="daterange"
                  range-separator="至"
                  format='yyyy.M.d'
                  style="width: 177px"
                  value-format='yyyy.M.d'
                  start-placeholder="开始日期"
                  end-placeholder="结束日期">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="发文日期">
                  <!-- <el-input  v-model="queryForm.releaseDate"></el-input> -->
                  <el-date-picker
                    style="width: 177px"
                    v-model="queryForm.releaseDate"
                    type="date"
                    value-format="yyyy.M.d"
                    placeholder="选择日期">
                  </el-date-picker>
              </el-form-item>
              <el-form-item label="申请号">
                  <el-input style="width: 177px" v-model="queryForm.applyNo"></el-input>
              </el-form-item>
			  <el-form-item label="商标名称">
			      <el-input style="width: 177px" v-model="queryForm.trademarkName"></el-input>
			  </el-form-item>
              <el-form-item label="类别">
                  <el-input style="width: 177px" v-model="queryForm.category"></el-input>
              </el-form-item>
              <el-form-item label="证件信息">
                  <el-input style="width: 177px" v-model="queryForm.certificateInfo"></el-input>
              </el-form-item>
              <el-form-item label="申请地址">
                  <el-input style="width: 177px" v-model="queryForm.applyAddress"></el-input>
              </el-form-item>
              <el-form-item label="受理情况">
                  <!-- <el-input  v-model="queryForm.acceptStatus"></el-input> -->
                  <el-select placeholder="请选择状态" clearable style="width: 177px"
                    size="small" v-model="queryForm.acceptStatus">
                    <el-option v-for='(item, index) in acceptStatusEnum' :key='index' :label="item.value"
                      :value="item.key">
                    </el-option>
                  </el-select>
              </el-form-item>
              <el-form-item label="证书情况">
                  <!-- <el-input  v-model="queryForm.certificateStatus"></el-input> -->
                  <el-select placeholder="请选择状态" clearable style="width: 177px"
                    size="small" v-model="queryForm.certificateStatus">
                    <el-option v-for='(item, index) in certificateStatusEnum' :key='index' :label="item.value"
                      :value="item.key">
                    </el-option>
                  </el-select>
              </el-form-item>
              <el-form-item label="业务员">
                  <el-input style="width: 177px" v-model="queryForm.saleMan"></el-input>
              </el-form-item>
              <el-form-item label="专用权期限">
                  <el-input style="width: 177px" v-model="queryForm.specialUse"></el-input>
              </el-form-item>
              <el-form-item label="联系人">
                  <el-input style="width: 177px" v-model="queryForm.contact"></el-input>
              </el-form-item>
              <el-form-item label="联系电话">
                  <el-input style="width: 177px" v-model="queryForm.telephone"></el-input>
              </el-form-item>
              <el-form-item label="QQ号">
                  <el-input style="width: 177px" v-model="queryForm.qq"></el-input>
              </el-form-item>
              <el-form-item label="邮箱">
                  <el-input style="width: 177px" v-model="queryForm.email"></el-input>
              </el-form-item>
              <el-form-item label="传真">
                  <el-input style="width: 177px" v-model="queryForm.fax"></el-input>
              </el-form-item>
              <el-form-item label="签单价格">
                  <el-input style="width: 177px" v-model="queryForm.signPrice"></el-input>
              </el-form-item>
              <el-form-item label="出账价格">
                  <el-input style="width: 177px" v-model="queryForm.outPrice"></el-input>
              </el-form-item>
              <el-form-item label="提醒日期">
                  <!-- <el-input  v-model="queryForm.nextPayTime"></el-input> -->
                  <el-date-picker
                    style="width: 177px"
                    v-model="queryForm.reminderDate"
                    type="date"
                    
                    value-format="yyyy.M.d"
                    placeholder="选择日期">
                  </el-date-picker>
              </el-form-item>
              <el-form-item label="所属公司">
                  <!-- <el-input  v-model="queryForm.companyId"></el-input> -->
                  <el-select
                    placeholder='请选择所属公司'
                    clearable
                    style='width: 177px'
                    size='small'
                    v-model='queryForm.companyId'
                  >
                    <el-option
                      v-for='(item,index) in companyList'
                      :key='index'
                      :label='item.companyName'
                      :value='item.id'
                    >
                    </el-option>
                  </el-select>
              </el-form-item>
              <el-form-item label="特殊备注">
                  <el-input style="width: 177px" v-model="queryForm.remarks"></el-input>
              </el-form-item>
              <el-form-item label="提醒类型">
                  <el-select placeholder="请选择类型" clearable style="width: 177px"
                      size="small" v-model="queryForm.reminderType">
                      <el-option v-for='(item, index) in propertyReminderType' :key='index' :label="item.value" :value="item.key"></el-option>
                  </el-select>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getPropertyTrademarkList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addPropertyTrademark"
        >新建</el-button>
        <el-button
          type="warning"
          plain
          size="small"
          icon="el-icon-edit"
          :disabled="multipleSelection.length != 1"
          @click="editPropertyTrademark(null)"
        >修改</el-button>
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deletePropertyTrademark(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
        <span
          class="icon-box"
          title="导入数据"
          @click="isImport"
        >
          <Icon color="#606266">
            <ArrowExportUp24Regular />
          </Icon>
        </span>
        <span
          title="导出数据"
          class="icon-box"
          @click="exportPropertyTrademarkList"
        >
          <Icon color="#606266">
            <ArrowDownload24Regular />
          </Icon>
        </span>
        <span
          class="icon-box"
          @click="refreshPropertyTrademarkList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="propertyTrademarkList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="archiveNo"
        label="案卷号"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="applyEntity"
        label="申请人"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="applyDate"
        label="申请日期"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="releaseDate"
        label="发文日期"
        width="180"
      > </el-table-column>
	  <el-table-column
	    :show-overflow-tooltip="true"
	    align="center"
	    prop="applyNo"
	    label="申请号"
	    width="180"
	  > </el-table-column>
	  
	  <el-table-column
	    :show-overflow-tooltip="true"
	    align="center"
	    prop="trademarkName"
	    label="商标名称"
	    width="180"
	  > </el-table-column>
      
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="category"
        label="类别"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="certificateInfo"
        label="证件信息"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="applyAddress"
        label="申请地址"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="acceptStatus"
        label="受理情况"
        width="180"
      > 
        <template slot-scope="scope">
          {{ acceptStatusEnums(scope.row.acceptStatus) }}
        </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="certificateStatus"
        label="证书情况"
        width="180"
      > 
      <template slot-scope="scope">
          {{ certificateStatusEnums(scope.row.certificateStatus) }}
        </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="saleMan"
        label="业务员"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="specialUse"
        label="专用权期限"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="remarks"
        label="特殊备注"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        v-if="isSa"
        prop="contact"
        label="联系人"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="telephone"
        label="联系电话"
        v-if="isSa"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="qq"
        label="QQ号"
        v-if="isSa"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="email"
        v-if="isSa"
        label="邮箱"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        v-if="isSa"
        prop="fax"
        label="传真"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="signPrice"
        label="签单价格"
        v-if="isSa"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="outPrice"
        v-if="isSa"
        label="出账价格"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="reminderDate"
        label="提醒日期"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="companyId"
        label="所属公司"
        width="180"
      >
        <template slot-scope="scope">
          {{ getCompanyLists(scope.row.companyId) }}
        </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="createTime"
        label="创建时间"
        width="180"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="checkPropertyTrademark(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
            <div @click="editPropertyTrademark(scop.row.id)">
              <Icon size="16">
                <Edit24Regular />
              </Icon>
              <span class="operation-label">修改</span>
            </div>
            <div @click="deletePropertyTrademark(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="propertyTrademarkStates[propertyTrademarkState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="propertyTrademark"
          ref="propertyTrademarkForm"
          :rules="rules"
          label-width="120px"
          :inline="true"
          size="small"
        >
          <el-form-item
            label="商标名称"
            prop="trademarkName"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="propertyTrademark.trademarkName"
              :disabled="propertyTrademarkState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="案卷号"
            prop="archiveNo"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="propertyTrademark.archiveNo"
              :disabled="propertyTrademarkState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="申请人"
            prop="applyEntity"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="propertyTrademark.applyEntity"
              :disabled="propertyTrademarkState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="申请日期"
            prop="applyDate"
          >
            <!-- <el-input
              size="small"
              v-model="propertyTrademark.applyDate"
              :disabled="propertyTrademarkState == 'check'"
            ></el-input> -->
            <el-date-picker
              style="width: 177px"
              :disabled="propertyTrademarkState == 'check'"
              v-model="propertyTrademark.applyDate"
              type="date"
              value-format="yyyy.M.d"
              placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item
            label="发文日期"
            prop="releaseDate"
          >
            <!-- <el-input
              size="small"
              v-model="propertyTrademark.releaseDate"
              :disabled="propertyTrademarkState == 'check'"
            ></el-input> -->
            <el-date-picker
              style="width: 177px"
              :disabled="propertyTrademarkState == 'check'"
              v-model="propertyTrademark.releaseDate"
              type="date"
              value-format="yyyy.M.d"
              placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item
            label="申请号"
            prop="applyNo"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="propertyTrademark.applyNo"
              :disabled="propertyTrademarkState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="类别"
            prop="category"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="propertyTrademark.category"
              :disabled="propertyTrademarkState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="证件信息"
            prop="certificateInfo"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="propertyTrademark.certificateInfo"
              :disabled="propertyTrademarkState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="申请地址"
            prop="applyAddress"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="propertyTrademark.applyAddress"
              :disabled="propertyTrademarkState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="受理情况"
            prop="acceptStatus"
          >
            <!-- <el-input
              size="small"
              v-model="propertyTrademark.acceptStatus"
              :disabled="propertyTrademarkState == 'check'"
            ></el-input> -->
            <el-select placeholder="请选择状态" :disabled="propertyTrademarkState == 'check'" clearable style="width: 177px"
                size="small" v-model="propertyTrademark.acceptStatus">
                <el-option v-for='(item, index) in acceptStatusEnum' :key='index' :label="item.value"
                  :value="item.key">
                </el-option>
              </el-select>
          </el-form-item>
          <el-form-item
            label="证书情况"
            prop="certificateStatus"
          >
            <!-- <el-input
              size="small"
              v-model="propertyTrademark.certificateStatus"
              :disabled="propertyTrademarkState == 'check'"
            ></el-input> -->
            <el-select placeholder="请选择状态" :disabled="propertyTrademarkState == 'check'" clearable style="width: 177px"
                size="small" v-model="propertyTrademark.certificateStatus">
                <el-option v-for='(item, index) in certificateStatusEnum' :key='index' :label="item.value"
                  :value="item.key">
                </el-option>
              </el-select>
          </el-form-item>
          <el-form-item
            label="业务员"
            prop="saleMan"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="propertyTrademark.saleMan"
              :disabled="propertyTrademarkState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="专用权期限"
            prop="specialUse"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="propertyTrademark.specialUse"
              :disabled="propertyTrademarkState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="联系人"
            prop="contact"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="propertyTrademark.contact"
              :disabled="propertyTrademarkState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="联系电话"
            prop="telephone"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="propertyTrademark.telephone"
              :disabled="propertyTrademarkState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="QQ号"
            prop="qq"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="propertyTrademark.qq"
              :disabled="propertyTrademarkState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="邮箱"
            prop="email"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="propertyTrademark.email"
              :disabled="propertyTrademarkState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="传真"
            prop="fax"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="propertyTrademark.fax"
              :disabled="propertyTrademarkState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="签单价格"
            prop="signPrice"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="propertyTrademark.signPrice"
              :disabled="propertyTrademarkState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="出账价格"
            prop="outPrice"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="propertyTrademark.outPrice"
              :disabled="propertyTrademarkState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="提醒日期"
            prop="reminderDate"
          >
            <!-- <el-input
              size="small"
              v-model="propertyTrademark.nextPayTime"
              :disabled="propertyTrademarkState == 'check'"
            ></el-input> -->
            <el-date-picker
              style="width: 177px"
              :disabled="propertyTrademarkState == 'check'"
              v-model="propertyTrademark.reminderDate"
              type="date"
              value-format="yyyy.M.d"
              placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item
            label="所属公司"
            prop="companyId"
          >
            <!-- <el-input
              size="small"
              v-model="propertyTrademark.companyId"
              :disabled="propertyTrademarkState == 'check'"
            ></el-input> -->
            <el-select
              placeholder='请选择所属公司'
              clearable
              style='width: 177px'
              size='small'
              v-model='propertyTrademark.companyId'
              :disabled="propertyTrademarkState == 'check'"
            >
              <el-option
                v-for='(item,index) in companyList'
                :key='index'
                :label='item.companyName'
                :value='item.id'
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="特殊备注"
            prop="remarks"
          >
            <el-input
              size="small"
              type="textarea"
              style="width: 29.11vw;"
              :rows="6"
              v-model="propertyTrademark.remarks"
              :disabled="propertyTrademarkState == 'check'"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="propertyTrademarkState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
    <!-- 导入 -->
    <el-dialog
      title="导入数据"
      :visible.sync="isImportDate"
      width="80%"
      @close="closeDialog1"
      >
      <div style="border-bottom: 1px solid #eee;display: flex;align-items: center;">
          <el-form
          :model="OnUploads"
          :rules="rules"
          ref="uupp"
          style="height: 45px;"
          label-width="100px"
          size="small"
          :inline="true"
          >
          <el-form-item
              label="所属公司"
              prop="companyId"
          >
              <!-- <el-input
              size="small"
              v-model="propertyPatent.companyId"
              :disabled="propertyPatentState == 'check'"
              ></el-input> -->
              <el-select
                  placeholder='请选择所属公司'
                  clearable
                  style='width: 180px'
                  size='small'
                  v-model='OnUploads.companyId'
                  >
                  <el-option
                      v-for='(item,index) in companyList'
                      :key='index'
                      :label='item.companyName'
                      :value='item.id'
                  >
                  </el-option>
              </el-select>
          </el-form-item>
          <el-form-item
              label="专利文件"
              prop="patentName11"
          >
              <!-- <el-input
              style="width: 177px"
              size="small"
              v-model="propertyPatent.patentName"
              :disabled="propertyPatentState == 'check'"
              ></el-input> -->
              <el-upload
                  class="upload-demo"
                  action="#"
                  :auto-upload="false"
                  :on-change="upload1"
                  :file-list="fileLists"
                  :show-file-list="true">
                  <el-tooltip class="item" effect="dark" content="只允许导入“xls”或“xlsx”格式文件！" placement="bottom">
                      <el-button size="small" type="primary">点击上传</el-button>
                  </el-tooltip>
                  <!-- <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div> -->
              </el-upload>
          </el-form-item>
          <el-form-item>
              <el-button type="primary" @click="okk">确定</el-button>
          </el-form-item>
          </el-form>
          <span v-if="counts">上传成功：{{ successList.length }}条，</span>
                <span v-if="counts">上传失败：{{ failList.length }}</span>
            </div>
            <el-tabs v-model="check" type="card">
              <el-tab-pane label="上传成功" name="true"></el-tab-pane>
              <el-tab-pane label="上传失败" name="false"></el-tab-pane>
            </el-tabs>
      <div style="height: 400px;">
          <!-- 列表数据 -->
          <el-table
      :data="nowList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      size="small"
    >
      <!-- <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column> -->
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="trademarkName"
        label="商标名称"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="archiveNo"
        label="案卷号"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="applyEntity"
        label="申请人"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="applyDate"
        label="申请日期"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="releaseDate"
        label="发文日期"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="applyNo"
        label="申请号"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="category"
        label="类别"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="certificateInfo"
        label="证件信息"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="applyAddress"
        label="申请地址"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="acceptStatus"
        label="受理情况"
        width="180"
      > 
        <template slot-scope="scope">
          {{ acceptStatusEnums(scope.row.acceptStatus) }}
        </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="certificateStatus"
        label="证书情况"
        width="180"
      > 
      <template slot-scope="scope">
          {{ certificateStatusEnums(scope.row.certificateStatus) }}
        </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="saleMan"
        label="业务员"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="specialUse"
        label="专用权期限"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="remarks"
        label="特殊备注"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        v-if="isSa"
        prop="contact"
        label="联系人"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="telephone"
        label="联系电话"
        v-if="isSa"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="qq"
        label="QQ号"
        v-if="isSa"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="email"
        v-if="isSa"
        label="邮箱"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        v-if="isSa"
        prop="fax"
        label="传真"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="signPrice"
        label="签单价格"
        v-if="isSa"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="outPrice"
        v-if="isSa"
        label="出账价格"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="reminderDate"
        label="提醒日期"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="companyId"
        label="所属公司"
        width="180"
      >
        <template slot-scope="scope">
          {{ getCompanyLists(scope.row.companyId) }}
        </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="createTime"
        label="创建时间"
        width="180"
      > </el-table-column>
    </el-table>
      </div>
      <div
          slot="footer"
          class="flex justify-end"
      >
          <el-button @click="closeDialog1">关闭</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetPropertyTrademarkList();
                    this.getPropertyTrademarkList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetPropertyTrademarkList();
                    this.getPropertyTrademarkList();
                    this.$emit('resetCheckState');
                }
            },
            check(){
              if(this.check == 'true'){
                  this.nowList = this.successList
              }else{
                  this.nowList = this.failList
              }
            }
        },
    data() {
            return {
                isSa:'',
                queryForm:{
                     trademarkName: '', //商标名称
                     archiveNo: '', //案卷号
                     applyEntity: '', //申请人
                     applyDate: '', //申请日期
                     releaseDate: '', //发文日期
                     applyNo: '', //申请号
                     category: '', //类别
                     certificateInfo: '', //证件情况
                     applyAddress: '', //申请地址
                     acceptStatus: '', //受理情况
                     certificateStatus: '', //证书情况
                     saleMan: '', //业务员
                     specialUse: '', //专用权期限
                     remarks: '', //特殊备注
                     contact: '', //联系人
                     telephone: '', //电话
                     qq: '', //QQ号
                     email: '', //邮箱
                     fax: '', //传真
                     signPrice: '', //签单价格
                     outPrice: '', //出账价格
                     nextPayTime: '', //下次缴费时间
                     companyId: '', //所属公司
                     reminderType:'',
                     startApplyDate:'',
                     endApplyDate:''
                },
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                propertyTrademarkState: 'add',
                propertyTrademarkStates: {
                    add: '新建商标',
                    check: '查看商标',
                    edit: '修改商标'
                },

                multipleSelection: [],
                propertyTrademarkList: [],
                propertyTrademark: {
                    trademarkName: '', //商标名称
                    archiveNo: '', //案卷号
                    applyEntity: '', //申请人
                    applyDate: '', //申请日期
                    releaseDate: '', //发文日期
                    applyNo: '', //申请号
                    category: '', //类别
                    certificateInfo: '', //证件情况
                    applyAddress: '', //申请地址
                    acceptStatus: '', //受理情况
                    certificateStatus: '', //证书情况
                    saleMan: '', //业务员
                    specialUse: '', //专用权期限
                    remarks: '', //特殊备注
                    contact: '', //联系人
                    telephone: '', //电话
                    qq: '', //QQ号
                    email: '', //邮箱
                    fax: '', //传真
                    signPrice: '', //签单价格
                    outPrice: '', //出账价格
                    nextPayTime: '', //下次缴费时间
                    companyId: '', //所属公司
                    createTime: '', //
                    updateTime:'',
                },
                btnLoading: false,

                rules: {
                    trademarkName: [{ required: true, message: '商标名称不能为空', trigger: 'blur' }],
                    archiveNo: [{ required: true, message: '案卷号不能为空', trigger: 'blur' }],
                    applyEntity: [{ required: true, message: '申请人不能为空', trigger: 'blur' }],
                    applyDate: [{ required: true, message: '申请日期不能为空', trigger: 'blur' }],
                    releaseDate: [{ required: true, message: '发文日期不能为空', trigger: 'blur' }],
                    applyNo: [{ required: true, message: '申请号不能为空', trigger: 'blur' }],
                    category: [{ required: true, message: '类别不能为空', trigger: 'blur' }],
                    certificateInfo: [{ required: true, message: '证件情况不能为空', trigger: 'blur' }],
                    applyAddress: [{ required: true, message: '申请地址不能为空', trigger: 'blur' }],
                    acceptStatus: [{ required: true, message: '受理情况不能为空', trigger: 'blur' }],
                    certificateStatus: [{ required: true, message: '证书情况不能为空', trigger: 'blur' }],
                    saleMan: [{ required: true, message: '业务员不能为空', trigger: 'blur' }],
                    specialUse: [{ required: true, message: '专用权期限不能为空', trigger: 'blur' }],
                    // remarks: [{ required: true, message: '特殊备注不能为空', trigger: 'blur' }],
                    contact: [{ required: true, message: '联系人不能为空', trigger: 'blur' }],
                    telephone: [{ required: true, message: '联系电话不能为空', trigger: 'blur' }],
                    // qq: [{ required: true, message: 'QQ号不能为空', trigger: 'blur' }],
                    // email: [{ required: true, message: '邮箱不能为空', trigger: 'blur' }],
                    // fax: [{ required: true, message: '传真不能为空', trigger: 'blur' }],
                    signPrice: [{ required: true, message: '签单价格不能为空', trigger: 'blur' }],
                    outPrice: [{ required: true, message: '出账价格不能为空', trigger: 'blur' }],
                    nextPayTime: [{ required: true, message: '下次缴费时间不能为空', trigger: 'blur' }],
                    companyId: [{ required: true, message: '所属公司不能为空', trigger: 'blur' }],
                    createTime: [{ required: true, message: '不能为空', trigger: 'blur' }],
                    companyId: [{ required: true, message: '所属不能为空', trigger: 'blur' }],
                },
                companyList: [],
                acceptStatusEnum:[],
                certificateStatusEnum:[],
                fileList:{},
                fileLists:[],
                OnUploads:{
                  companyId:''
                },
                companyList:[],
                propertyReminderType:[],
                dataLabel1:'',
                nowList:[],
                successList:[],
                failList:[],
                check: "true",
                counts: false
            };
        },
        created() {
            this.getPropertyTrademarkList();
            this.getCompanyList();
            this.getProductStatusEnum()
            this.getCompanyList()
            this.getpropertyReminderTypeList()
        },
        methods: {
            // 提醒
            getpropertyReminderTypeList() {
              get('/mpp/utils/getEnum', {
                  enumType: 'property_reminder_type',
                }).then((res) => {
                  if (res.success) {
                    // console.log(res.enumList)
                    this.propertyReminderType = res.enumList
                  }
                })
            },
            // 公司列表
            getCompanyList() {
                get('/property/company/findAll').then((res) => {
                    if (res.success) {
                        // console.log(res.list)
                        this.companyList = res.list
                    }
                })
            },
            // 公司列表
            getCompanyLists(type){
              for (let i = 0; i < this.companyList.length; i++) {
                if(this.companyList[i].id == type){
                    return this.companyList[i].companyName
                }
              }
            },
            isImport() {
                this.isImportDate = true;
            },
            closeDialog1(){
                this.fileList = {}
                this.OnUploads = {
                companyId:''
                }
                this.nowList = []
                this.successList = []
                this.failList = []
                this.isImportDate = false
                this.counts = false
                this.getPropertyTrademarkList();
            },
            upload1(file){
                console.log(file)
                this.fileList = file
            },
            okk(){
              this.$refs.uupp.validate((valid) => {
                if(valid){
                  let formData = new FormData();
                  formData.append('file',this.fileList.raw)
                  formData.append('companyId',this.OnUploads.companyId)
                  console.log(this.fileList)
                  importDate(`/property/trademark/import`,formData).then((res) => {
                      if (res.success) {
                          this.fileLists = []
                          this.successList = res.imported
                          this.failList = res.notimported
                          this.nowList = res.imported
                          this.check = "true"
                          this.counts = true
                      }else{
                        this.$message.error(res.message)
                      }
                  });
                  }
              })
            },
          getProductStatusEnum() {
              // 受理状态
              get('/mpp/utils/getEnum', {
                enumType: 'property_accept_status',
              }).then((res) => {
                if (res.success) {
                  console.log(res.enumList)
                  this.acceptStatusEnum = res.enumList
                }
              })
              // 证书状态
              get('/mpp/utils/getEnum', {
                enumType: 'property_certificate_status',
              }).then((res) => {
                if (res.success) {
                  // console.log(res.enumList)
                  this.certificateStatusEnum = res.enumList
                }
              })
            },
            // 受理状态
            acceptStatusEnums(type){
              // console.log(type)
              for (let i = 0; i < this.acceptStatusEnum.length; i++) {
                if(this.acceptStatusEnum[i].key == type){
                    return this.acceptStatusEnum[i].value
                }
              }
            },
            // 证书状态
            certificateStatusEnums(type){
              for (let i = 0; i < this.certificateStatusEnum.length; i++) {
                if(this.certificateStatusEnum[i].key == type){
                    return this.certificateStatusEnum[i].value
                }
              }
            },
            // 公司列表
            getCompanyList() {
                get('/property/company/findAll').then((res) => {
                    if (res.success) {
                        // console.log(res.list)
                        this.companyList = res.list
                    }
                })
            },
            // 公司列表
            getCompanyLists(type){
              // console.log(type)
              for (let i = 0; i < this.companyList.length; i++) {
                if(this.companyList[i].id == type){
                    return this.companyList[i].companyName
                }
              }
            },
            search(){
                this.isSearch = !this.isSearch;
            },
            resetPropertyTrademarkList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.propertyTrademarkList = [];
            },
            resetDialog() {
                this.propertyTrademarkState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      trademarkName: '', //商标名称
                      archiveNo: '', //案卷号
                      applyEntity: '', //申请人
                      applyDate: '', //申请日期
                      releaseDate: '', //发文日期
                      applyNo: '', //申请号
                      category: '', //类别
                      certificateInfo: '', //证件情况
                      applyAddress: '', //申请地址
                      acceptStatus: '', //受理情况
                      certificateStatus: '', //证书情况
                      saleMan: '', //业务员
                      specialUse: '', //专用权期限
                      remarks: '', //特殊备注
                      contact: '', //联系人
                      telephone: '', //电话
                      qq: '', //QQ号
                      email: '', //邮箱
                      fax: '', //传真
                      signPrice: '', //签单价格
                      outPrice: '', //出账价格
                      reminderDate: '', //下次缴费时间
                      companyId: '', //所属公司
                      reminderType:'',
                      startApplyDate:'',
                      endApplyDate:'',
                };
                this.dataLabel1 = ''
                this.getPropertyTrademarkList();
            },
            closeDialog() {
                this.showDialog = false
                this.propertyTrademark = {
                      trademarkName: '', //商标名称
                      archiveNo: '', //案卷号
                      applyEntity: '', //申请人
                      applyDate: '', //申请日期
                      releaseDate: '', //发文日期
                      applyNo: '', //申请号
                      category: '', //类别
                      certificateInfo: '', //证件情况
                      applyAddress: '', //申请地址
                      acceptStatus: '', //受理情况
                      certificateStatus: '', //证书情况
                      saleMan: '', //业务员
                      specialUse: '', //专用权期限
                      remarks: '', //特殊备注
                      contact: '', //联系人
                      telephone: '', //电话
                      qq: '', //QQ号
                      email: '', //邮箱
                      fax: '', //传真
                      signPrice: '', //签单价格
                      outPrice: '', //出账价格
                      reminderDate: '', //下次缴费时间
                      companyId: '', //所属公司
                      createTime: '', //
                      updateTime:''
                };
            },
            submitForm() {
                if (this.propertyTrademarkState == 'add') {
                    this.$refs.propertyTrademarkForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/property/trademark/add`,{ ...this.propertyTrademark }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetPropertyTrademarkList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.propertyTrademarkState == 'edit') {
                    this.$refs.propertyTrademarkForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            delete this.propertyTrademark.company
                            post(`/property/trademark/edit`,{ ...this.propertyTrademark }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetPropertyTrademarkList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addPropertyTrademark() {
                this.showDialog = true;
                this.propertyTrademarkState = 'add';
            },
            checkPropertyTrademark(propertyTrademarkId) {
                console.log(propertyTrademarkId);
                this.currentPropertyTrademarkId = propertyTrademarkId;

                this.getPropertyTrademarkById();
                this.showDialog = true;
                this.propertyTrademarkState = 'check';
            },
            editPropertyTrademark(propertyTrademarkId) {
                console.log('propertyTrademark', propertyTrademarkId);
                if (propertyTrademarkId) {
                    this.currentPropertyTrademarkId = propertyTrademarkId;
                    this.getPropertyTrademarkById();
                } else {
                    this.propertyTrademark = { ...this.propertyTrademark, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.propertyTrademarkState = 'edit';
            },
            deletePropertyTrademark(propertyTrademarkId) {
                let ids = '';
                if (propertyTrademarkId) {
                    ids = propertyTrademarkId;
                } else {
                    ids = this.multipleSelection.map((propertyTrademark) => propertyTrademark.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/property/trademark/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetPropertyTrademarkList();
                                this.getPropertyTrademarkList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshPropertyTrademarkList() {
                this.resetPropertyTrademarkList();
                this.getPropertyTrademarkList();
            },
            getPropertyTrademarkList(query = {}) {
                this.loading = true;
                if(this.dataLabel1 != null){
                  this.queryForm.startApplyDate = this.dataLabel1[0]
                  this.queryForm.endApplyDate = this.dataLabel1[1]
                }else{
                  this.queryForm.startApplyDate = ''
                  this.queryForm.endApplyDate = ''
                }
                get(`/property/trademark/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.propertyTrademarkList = res.page.list;
                        this.totalNum = res.page.total;
                        this.isSa = res.isSa
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getPropertyTrademarkById() {
                get(`/property/trademark/get`,{ id: this.currentPropertyTrademarkId }).then((res) =>{
                    if(res.success){
                      this.propertyTrademark = { ...this.propertyTrademark, ...res.propertyTrademark };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportPropertyTrademarkList() {
                //this.btnLoading = true;
                exprotExcel(`/property/trademark/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/property/trademark/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/property/trademark/importData`,formData);
              this.refreshPropertyTrademarkList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getPropertyTrademarkList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getPropertyTrademarkList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  button{
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
.avatar {
  width: 180px;
  height: 180px;
  display: block;
}

::v-deep .el-upload--text {
  width: 80px;
  height: 32px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 150px;
  height: 150px;
  line-height: 180px;
  text-align: center;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
</style>